exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".score-item {\n  display: flex;\n  justify-content: space-around;\n  margin-top: 5px;\n  border-radius: 5px; }\n  .score-item span {\n    width: 50%;\n    text-align: center; }\n\n.score-item:nth-child(odd) {\n  background-color: lightgrey; }\n", ""]);

